import * as yup from 'yup'
import {ErrorMessages} from "./messages";

export const seventhStepSchema = yup.object().shape({
    drivingLicenseFile: yup.mixed().required(ErrorMessages.REQUIRED)
})
